import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import type { RemovedEmployeeResponse } from "@/types/generated/cms.generated";

/**
 * Employees an organisation has removed (switched off, awaiting erasure). Read-only in the CMS —
 * HR reactivates from the client portal. CMS API `GET /organizations/{organizationId}/employees/removed`.
 */
export function useRemovedEmployees(organizationId: string | null | undefined) {
  return useQuery<RemovedEmployeeResponse[]>({
    queryKey: ["organizations", organizationId, "employees", "removed"],
    queryFn: () =>
      apiRequest<RemovedEmployeeResponse[]>("GET", `/organizations/${organizationId}/employees/removed`),
    enabled: !!organizationId,
  });
}
